import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import logoImg from "../../../assets/images/branding/logo-torneiofacil.png";

import Button from "../../../components/atoms/button";
import Input from "../../../components/atoms/input";
import EmailInput from "../../../components/atoms/input-email";
import InputMaskCustom from "../../../components/atoms/input-mask-custom";
import Select from "../../../components/atoms/select";
import Navbar from "../../../components/organisms/navbar";
import api from "../../../services/api";
import {
  AccountExists,
  Container,
  Content,
  FormContent,
  FormGroup,
  PageDescription,
  PageLogo,
  PageTitle,
  SectionBanner,
  SectionForm,
  TermDescription,
} from "./styles";
import Swal from "sweetalert2";
import { Box, CircularProgress, Typography } from "@mui/material";

const Register: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [avatarFile, setAvatarFile] = useState<File | null>(null);
  const [avatarPreview, setAvatarPreview] = useState<string | null>(null);
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    reset,
  } = useForm();

  const handleAvatarChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      if (file.size > 2 * 1024 * 1024) {
        toast.error("A imagem deve ter no máximo 2MB");
        return;
      }
      setAvatarFile(file);
      setAvatarPreview(URL.createObjectURL(file));
    }
  };

  const navigate = useNavigate();

  // Resetar o formulário sempre que a tela carregar
  useEffect(() => {
    reset();
  }, [reset]);

  const password = React.useRef({});
  password.current = watch("password", "");

  const belts = [
    { title: "Branca", option: 1 },
    { title: "Cinza", option: 2 },
    { title: "Amarela", option: 3 },
    { title: "Laranja", option: 4 },
    { title: "Verde", option: 5 },
    { title: "Azul", option: 6 },
    { title: "Roxa", option: 7 },
    { title: "Marrom", option: 8 },
    { title: "Preta", option: 9 },
  ];

  const emalteste = watch("email");
  console.log(emalteste);

  const onSubmit = (data: any) => {
    setLoading(true);

    if (data.password !== data.confirmPassword) {
      Swal.fire({
        title: "Atenção!",
        text: `A senha e a confirmação de senha devem ser iguais.`,
        icon: "error",
      });
      setLoading(false);
      return toast.error("A senha e a confirmação de senha devem ser iguais.");
    }

    delete data.confirmPassword;

    api
      .post("/auth/register", {
        ...data,
        name: data.name.trim(),
        mother_name: data.mother_name.trim(),
        gym: data.gym.toLowerCase().trim(),
        belt: +data.belt,
        genre: data.genre.toLowerCase().trim(),
        email: data.email.toLowerCase().trim(),
        password: data.password.trim(),
      })
      .then(async (response: any) => {
        // Upload do avatar se foi selecionado
        if (avatarFile && response.data?.token) {
          try {
            const formData = new FormData();
            formData.append("avatar", avatarFile);
            await api.post("/me/avatar", formData, {
              headers: {
                Authorization: `Bearer ${response.data.token}`,
                "Content-Type": "multipart/form-data",
              },
            });
          } catch {}
        }
        setLoading(false);
        toast.success("A sua conta foi criada com sucesso!");

        const responseData = JSON.parse(response.config.data);
        const emailDomain = responseData.email.split("@")[1];

        Swal.fire({
          title: "Ative sua conta",
          html: `Enviamos um email de ativação para <b>${responseData.email}</b> <br/> Por favor verifique sua caixa de entrada (ou spam) e ative sua conta para poder acessar o sistema.`,
          icon: "success",
          confirmButtonText: "Ativar conta",
          confirmButtonColor: "#1a2252",
        }).then((willRedirect: any) => {
          if (willRedirect.isConfirmed) {
            window.open(`https://${emailDomain}`, "_blank");
            navigate("/login");
          }
          navigate("/login");
        });
      })
      .catch((error) => {
        setLoading(false);
        if (error?.response?.data?.message?.includes("Email")) {
          Swal.fire({
            title: error.response.data.message,
            text: "O e-mail informado já está cadastrado! Por favor, informe outro e-mail ou faça o login!",
            icon: "error",
            showCancelButton: true,
            confirmButtonText: "Fazer login",
            confirmButtonColor: "#1a2252",
            cancelButtonText: "Informar outro e-mail",
          }).then((result) => {
            if (result.isConfirmed) {
              navigate("/login");
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              const emailInput = document.querySelector<HTMLInputElement>(
                'input[name="email"]'
              );
              const passwordInput = document.querySelector<HTMLInputElement>(
                'input[name="password"]'
              );
              const confirmPasswordInput =
                document.querySelector<HTMLInputElement>(
                  'input[name="confirmPassword"]'
                );

              if (emailInput) {
                emailInput.value = "";
                passwordInput!.value = "";
                confirmPasswordInput!.value = "";
                setTimeout(() => {
                  emailInput.focus();
                }, 1000);
              }
            }
          });
          return;
        }

        Swal.fire({
          title: "Atenção!",
          text: "Não foi possível criar a sua conta, Tente novamente mais tarde.",
          icon: "error",
        });
      });
  };

  return (
    <>
    <Navbar />
    <Container>
      {loading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center", // centraliza horizontalmente
            alignItems: "center", // centraliza verticalmente
            backdropFilter: "blur(6px)", // 👈 aplica o blur no fundo
            backgroundColor: "rgba(255, 255, 255, 0.4)", // leve transparência
            zIndex: 2000, // garante que fica acima de tudo
            gap: 2,
          }}
        >
          <Typography
            sx={{ fontFamily: "var(--font-body)", fontSize: "1.1rem", color: "var(--navy)" }}
          >
            Aguarde, estamos realizando seu cadastro...
          </Typography>

          <CircularProgress sx={{ color: "var(--navy)" }} />
        </Box>
      )}

      <SectionForm>
        <Content>
          <Link to={"/"}>
            <PageLogo src={logoImg} />
          </Link>
          <PageTitle>Cadastre-se</PageTitle>
          <PageDescription>
            Bem-vindo ao Torneio Fácil.
            <br />
            Para se cadastrar preencha os dados abaixo.
          </PageDescription>
          <FormContent onSubmit={handleSubmit(onSubmit)}>
            <FormGroup>
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "8px" }}>
                <label htmlFor="avatar-upload" style={{ cursor: "pointer" }}>
                  <div style={{
                    width: "80px",
                    height: "80px",
                    borderRadius: "50%",
                    background: avatarPreview ? `url(${avatarPreview}) center/cover` : "#e5e7eb",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "2px dashed #9ca3af",
                    overflow: "hidden",
                  }}>
                    {!avatarPreview && (
                      <span style={{ fontSize: "1.8rem", color: "#9ca3af" }}>📷</span>
                    )}
                  </div>
                </label>
                <input
                  id="avatar-upload"
                  type="file"
                  accept="image/jpeg,image/png,image/webp"
                  onChange={handleAvatarChange}
                  style={{ display: "none" }}
                />
                <span style={{ fontSize: "0.75rem", color: "#888" }}>
                  Foto (opcional) - máx. 2MB
                </span>
              </div>
            </FormGroup>
            <FormGroup>
              <Input
                label="Nome completo"
                name="name"
                type="text"
                register={register}
                required
                hasError={!!errors.name}
                error="Este campo é obrigatório"
              />
            </FormGroup>
            <FormGroup>
              <Input
                label="Nome da mãe"
                name="mother_name"
                type="text"
                register={register}
                required
                hasError={!!errors.mother_name}
                error="Este campo é obrigatório"
              />
            </FormGroup>
            <FormGroup>
              <InputMaskCustom
                label="Telefone"
                name="phone"
                mask="(99) 99999-9999"
                register={register}
                required
                hasError={!!errors.phone}
                error="Este campo é obrigatório"
              />
            </FormGroup>
            <FormGroup>
              <InputMaskCustom
                label="Data de nascimento"
                name="birth_date"
                mask="99/99/9999"
                register={register}
                required
                hasError={!!errors.birth_date}
                error="Este campo é obrigatório"
              />
            </FormGroup>
            <FormGroup>
              <Input
                label="Academia"
                name="gym"
                type="text"
                register={register}
                required
                hasError={!!errors.gym}
                error="Este campo é obrigatório"
              />
            </FormGroup>
            <FormGroup>
              <Select
                label="Faixa"
                name="belt"
                register={register}
                required
                hasError={!!errors.belt}
                error="Este campo é obrigatório"
                options={belts}
              />
            </FormGroup>
            <FormGroup>
              <Select
                label="Sexo"
                name="genre"
                register={register}
                required
                hasError={!!errors.genre}
                error="Este campo é obrigatório"
                options={[
                  { title: "Masculino", option: "masculino" },
                  { title: "Feminino", option: "feminino" },
                ]}
              />
            </FormGroup>
            <FormGroup>
              <EmailInput
                label="E-mail"
                name="email"
                register={register}
                required
                hasError={!!errors.email}
                error="Este campo é obrigatório"
              />
            </FormGroup>
            <FormGroup>
              <Input
                label="Senha"
                name="password"
                type="password"
                register={register}
                required
                hasError={!!errors.password}
                error="Este campo é obrigatório"
              />
            </FormGroup>
            <FormGroup>
              <Input
                label="Confirmar senha"
                name="confirmPassword"
                type="password"
                register={register}
                required
                hasError={!!errors.confirmPassword}
                error="Este campo é obrigatório"
              />
            </FormGroup>

            <FormGroup>
              <TermDescription>
                Ao criar a sua conta você estará de acordo com a política e
                termos de uso do Torneio Fácil.
              </TermDescription>
            </FormGroup>
            <FormGroup>
              <Button type="submit" label="Cadastrar" />
            </FormGroup>
            <FormGroup>
              <AccountExists href="/login">
                Já possui conta? Entre aqui
              </AccountExists>
            </FormGroup>
          </FormContent>
        </Content>
      </SectionForm>
      <SectionBanner />
    </Container>
    </>
  );
};

export default Register;
